import { useTranslation } from 'react-i18next';
import Flex from '../Flex';
import { ReactComponent as SamadLogo } from '@/assets/images/logo-samad.svg';

export const LoadingApp = () => {
  const [t] = useTranslation(['common']);
  return (
    <Flex direction="column" align="center" justify="center" style={{ width: '100vw', height: '100vh' }}>
      <SamadLogo style={{ fill: '#444', width: '47px', height: '31px' }} />
      <b style={{ color: '#444', fontSize: '1.25rem' }}>{t('common:app.name_')}</b>
      <div aria-busy="true">
        <svg width="40" height="40" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill="#444" aria-label="audio-loading">
          <circle cx="15" cy="15" r="15">
            <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate>
            <animate attributeName="fillOpacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" attributeName="fillOpacity" from="1" to="0.3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fillOpacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fillOpacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate>
          </circle>
        </svg>
      </div>
    </Flex>
  );
};

export default LoadingApp;
